export default "__VITE_ASSET__d4a224dd__"